<app-modal
  [options]="modalOptions"
  [isSaving]="isSaving"
  (positiveClick)="saveProfile()"
  (closeClick)="closeModal()"
>
  <div class="profile-modal__header">
    @if (noticeKey) {
      <app-alert-notice
        [message]="noticeKey"
        [icon]="
          missingAvatar && !missingRequired
            ? 'fa-camera'
            : 'fa-circle-exclamation'
        "
      ></app-alert-notice>
    }

    <app-profile-completeness
      class="profile-modal__completeness"
      [profile]="profile"
      [variant]="'compact'"
    ></app-profile-completeness>
  </div>

  <app-my-profile
    #myProfile
    [hideActions]="true"
    [highlightAvatar]="missingAvatar"
  ></app-my-profile>
</app-modal>
